import CheckboxGroup from './checkbox-group.vue'

CheckboxGroup.install = function (Vue) {
	Vue.component(CheckboxGroup.name, CheckboxGroup);
}

export default CheckboxGroup;